<template>
    <div class="doc-content">
        <section class="doc-header">
            <h1>Monitoreo</h1>
            <p class="lead">
                El apartado de monitoreo permite la visualización en tiempo real de los dispositivos GPS sobre un mapa
                interactivo y la ejecución de acciones específicas(ver, editar, ver geocercas, ver dispositivos a la
                redonda) sobre los dispositivos GPS.
            </p>
        </section>
        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <hr />

        <div v-if="plataforma === 'web'" class="platform-content">
            <section class="doc-section">
                <h2>Acceso a Dispositivos</h2>
                <p>
                    En la interfaz principal de monitoreo, encontrará dos botones en la parte superior. Para
                    gestionar sus dispositivos, sigsa estos pasos:
                </p>
                <ol class="step-list">
                    <li>Ubique los botones de control en la <strong>parte superior</strong> del mapa.
                    </li>
                    <li>Seleccione el botón con la leyenda: <strong>Dispositivos y Ubicaciones</strong>.
                        <CarruselAciqui :items="[imagenesMonitoreo[0]]" />
                    </li>
                    <li>
                        Al hacer clic, se desplegará un <strong>menú lateral derecho</strong> que contiene el listado de
                        todos los dispositivos GPS activos.
                        <CarruselAciqui :items="[imagenesMonitoreo[1]]" />
                    </li>
                </ol>
            </section>

            <section class="doc-section">
                <h2>Interacción con la Tabla</h2>
                <p>
                    Dentro del menú desplegable derecho, encontrará una tabla informativa donde se indican:
                </p>
                <div class="info-grid">
                    <div class="info-card">
                        <span class="icon">🏷️</span>
                        <strong>Nombre</strong>
                        <p>Identificación del dispositivo GPS.</p>
                    </div>
                    <div class="info-card">
                        <span class="icon">⚙️</span>
                        <strong>Acciones</strong>
                        <p>Herramientas disponibles para realizar sobre el GPS seleccionado.</p>
                    </div>
                </div>
            </section>

            <section class="doc-section">
                <h2>Acciones de la Tabla</h2>
                <p>Cada dispositivo en el listado cuenta con las siguientes herramientas de interacción:</p>

                <div class="info-grid">
                    <div class="card">
                        <p><strong>Ver:</strong> Muestra el marcador del dispositivo seleccionado directamente en el
                            mapa.
                        </p>
                    </div>
                    <div class="card">
                        <p><strong>Editar:</strong> Abre el formulario con los datos del dispositivo para poder
                            actualizar
                            su información.</p>
                    </div>
                    <div class="card">
                        <p><strong>Geocercas:</strong> Visualiza en el mapa las geocercas o perímetros asignados al
                            dispositivo.</p>
                    </div>
                    <div class="card">
                        <p><strong>Dispositivos a la redonda:</strong> Busca y muestra otras unidades que se encuentren
                            dentro del rango definido.</p>
                    </div>
                </div>
            </section>

            <CarruselAciqui :items="[imagenesMonitoreo[2]]" />

            <section class="doc-note">
                <div class="alert-info">
                    <p>
                        <strong>Consejo de uso:</strong> Puede mantener el menú de dispositivos abierto para alternar
                        rápidamente entre diferentes ubicaciones sin perder la vista del mapa.
                    </p>
                </div>
            </section>
        </div>


        <div v-if="plataforma === 'moviles'" class="platform-content">
            <section class="doc-section">
                <h2>Acceso a Dispositivos</h2>
                <p>
                    En la interfaz principal de monitoreo, encontrará dos botones en la parte superior. Para
                    gestionar sus dispositivos, sigsa estos pasos:
                </p>
                <ol class="step-list">
                    <li>Ubique los botones de control en la <strong>parte superior</strong> del mapa.
                    </li>
                    <li>Seleccione el botón con la leyenda: <strong>Dispositivos y Ubicaciones</strong>.
                        <CarruselAciqui :items="[imagenesMonitoreoMoviles[0]]" />
                    </li>
                    <li>
                        Al hacer clic, se desplegará un <strong>menú lateral derecho</strong> que contiene el listado de
                        todos los dispositivos GPS activos.
                        <CarruselAciqui :items="[imagenesMonitoreoMoviles[1]]" />
                    </li>
                </ol>
            </section>

            <section class="doc-section">
                <h2>Interacción con la Tabla</h2>
                <p>
                    Dentro del menú desplegable derecho, encontrará una tabla informativa donde se indican:
                </p>
                <div class="info-grid">
                    <div class="info-card">
                        <span class="icon">🏷️</span>
                        <strong>Nombre</strong>
                        <p>Identificación del dispositivo GPS.</p>
                    </div>
                    <div class="info-card">
                        <span class="icon">⚙️</span>
                        <strong>Acciones</strong>
                        <p>Herramientas disponibles para realizar sobre el GPS seleccionado.</p>
                    </div>
                </div>
            </section>

            <section class="doc-section">
                <h2>Acciones de la Tabla</h2>
                <p>Cada dispositivo en el listado cuenta con las siguientes herramientas de interacción:</p>

                <div class="info-grid">
                    <div class="card">
                        <p><strong>Ver:</strong> Muestra el marcador del dispositivo seleccionado directamente en el
                            mapa.
                        </p>
                    </div>
                    <div class="card">
                        <p><strong>Editar:</strong> Abre el formulario con los datos del dispositivo para poder
                            actualizar
                            su información.</p>
                    </div>
                    <div class="card">
                        <p><strong>Geocercas:</strong> Visualiza en el mapa las geocercas o perímetros asignados al
                            dispositivo.</p>
                    </div>
                    <div class="card">
                        <p><strong>Dispositivos a la redonda:</strong> Busca y muestra otras unidades que se encuentren
                            dentro del rango definido.</p>
                    </div>
                </div>
            </section>

            <CarruselAciqui :items="[imagenesMonitoreoMoviles[2]]" />

            <section class="doc-note">
                <div class="alert-info">
                    <p>
                        <strong>Consejo de uso:</strong> Puede mantener el menú de dispositivos abierto para alternar
                        rápidamente entre diferentes ubicaciones sin perder la vista del mapa.
                    </p>
                </div>
            </section>
        </div>


    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'MonitoreoDoc',
    components: {
        CarruselAciqui,
        plataformaNavegacion
    },
    data() {
        return {
            plataforma: 'web',
            imagenesMonitoreo: [
                {
                    nombre: "",
                    url: "img/monitoreo/pantalla_principal.png",
                    descripcion: ""
                },
                {
                    nombre: "",
                    url: "img/monitoreo/menu_derecho.png",
                    descripcion: ""
                },
                { nombre: "", url: "img/monitoreo/acciones_tabla.png" }
            ],
            imagenesMonitoreoMoviles: [
                {
                    nombre: "",
                    url: "img/monitoreo/moviles/monitoreo.png",
                    descripcion: ""
                },
                {
                    nombre: "",
                    url: "img/monitoreo/moviles/barDispositivos.png",
                    descripcion: ""
                },
                { nombre: "", url: "img/monitoreo/acciones_tabla.png" }
            ]
        }
    },
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>

<style scoped>
.doc-content {
    line-height: 1.6;
    color: inherit;
}

h1 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #3b82f6;
}

h2 {
    font-size: 1.5rem;
    margin-top: 2rem;
    border-bottom: 1px solid #eaecef;
    padding-bottom: 0.3rem;
}

h3 {
    font-size: 1.1rem;
    margin-top: 1.5rem;
    color: #666;
    text-align: center;
}

.lead {
    font-size: 1.1rem;
    color: #6a737d;
}

.step-list {
    padding-left: 2rem;
    margin-bottom: 1.5rem;
}

.step-list li {
    margin-bottom: 0.8rem;
}

/* Grid para explicar la tabla */
.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    margin-top: 1rem;
}

.info-card {
    background: rgba(59, 130, 246, 0.05);
    padding: 15px;
    border-radius: 8px;
    border: 1px solid rgba(59, 130, 246, 0.1);
    text-align: center;
}

.info-card .icon {
    font-size: 1.5rem;
    display: block;
    margin-bottom: 5px;
}

.figure-labels {
    display: flex;
    justify-content: space-around;
    font-size: 0.85rem;
    color: #586069;
    margin-top: 10px;
    border-top: 1px dashed #ddd;
    padding-top: 10px;
}

.alert-info {
    background-color: #e3f2fd;
    border-left: 0.25em solid #2196f3;
    padding: 1rem;
    margin-top: 2rem;
    border-radius: 3px;
    color: #0d47a1;
}

.carrusel-container {
    margin: 20px 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
}
</style>